import { ACTIVE_ASSAILANT } from '@rsos/base-constants/alertEmergencyTypes';
import { TRAIN_INCIDENT_ALERT_TYPE } from '@rsos/base-constants/alertTypes';
import {
  AGENCY_CHAT,
  ALERTS,
  type IncidentType,
} from '@rsos/constants/incidentTypes';
import styles from './Tabs.module.scss';

export type NotifyByAlertType =
  | typeof ACTIVE_ASSAILANT
  | typeof TRAIN_INCIDENT_ALERT_TYPE
  | null;

export const getTabClass = (
  active: boolean,
  notifyByAlertType: NotifyByAlertType,
): string =>
  [
    styles.tab,
    active && styles.active,
    notifyByAlertType === ACTIVE_ASSAILANT && styles.notifyAssailant,
    notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE && styles.notifyTrain,
  ]
    .filter(Boolean)
    .join(' ');

export const getIconClass = (
  type: IncidentType,
  notifyByAlertType: NotifyByAlertType,
): string => {
  if (type === AGENCY_CHAT) return `${styles.iconWrapper} ${styles.agencyChat}`;
  if (type === ALERTS) {
    if (notifyByAlertType === ACTIVE_ASSAILANT)
      return `${styles.iconWrapper} ${styles.notifyAssailant}`;
    if (notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE)
      return `${styles.iconWrapper} ${styles.notifyTrain}`;
    return `${styles.iconWrapper} ${styles.alerts}`;
  }
  return styles.iconWrapper;
};

export const getLabelClass = (
  type: IncidentType,
  notifyByAlertType: NotifyByAlertType,
): string => {
  if (type === AGENCY_CHAT) return `${styles.tabLabel} ${styles.agencyChat}`;
  if (type === ALERTS) {
    if (notifyByAlertType === ACTIVE_ASSAILANT)
      return `${styles.tabLabel} ${styles.notifyAssailant}`;
    if (notifyByAlertType === TRAIN_INCIDENT_ALERT_TYPE)
      return `${styles.tabLabel} ${styles.notifyTrain}`;
    return `${styles.tabLabel} ${styles.alerts}`;
  }
  return styles.tabLabel;
};
